<template>
    <div class="view">
        <MapView v-if="$store.state.user.authenticated && $store.state.ui.ready"></MapView>
        <LoginView v-show="!$store.state.user.authenticated && $store.state.ui.ready"></LoginView>
    </div>
</template>

<script>
import LoginView from './LoginView';
import MapView from './MapView';

export default {
    name: 'Main',
    data() {
        return {};
    },
    components: { LoginView, MapView },
    mounted() {
        if (this.$route.query.api) {
            this.$store.dispatch('data/NEW_API', this.$route.query.api);

            // remove api query string and reload, so it takes effect
            let query = Object.assign({}, this.$route.query);
            delete query.api;
            this.$router.replace({ query });
            window.location.reload();
        }
        this.$store.dispatch('auth');
    }
};
</script>

<style lang="scss">
    .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: black;
        visibility: hidden;
        z-index: 1550;
        opacity: 0;
        cursor: pointer;
        transition: visibility 0.18s, opacity 0.18s linear;
    }

    .overlay--visible {
        visibility: visible;
        opacity: 0.3;
    }

    .view,
    .view > div {
        height: 100%;
        /*margin: 0;*/
    }

    .close-button {
        position: absolute;
        top: 0.6em;
        right: 0.6em;
        font-size: 1.2em;
        cursor: pointer;
    }

    .nowrap {
        white-space: nowrap;
    }
</style>
